import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MapLayersEnum } from '../../constants/enums'

interface AppState {
  isSideBarOpened: boolean
  isSideBarGoingToClose: boolean
  isSideBarCloseInitiated: boolean
  shouldLocateUser: boolean

  isPointAndEventPanelOpen: boolean
  currentTabSelected: string

  isNewEventFormOpened: boolean
  isNewPointOpened: boolean
  isEditEventFormOpened: boolean
  isEventInfoOpened: boolean
  isEventListOpened: boolean

  isNewPointFormOpened: boolean
  isEditPointFormOpened: boolean
  isPointInfoOpened: boolean
  isPointListOpened: boolean

  isLocationInfoOpened: boolean
  mapLayer: MapLayersEnum
}

const initialState: AppState = {
  isSideBarOpened: true,
  isSideBarGoingToClose: false,
  isSideBarCloseInitiated: false,
  shouldLocateUser: false,

  isPointAndEventPanelOpen: true,
  currentTabSelected: 'locations',

  isNewEventFormOpened: false,
  isNewPointOpened: false,
  isEditEventFormOpened: false,
  isEventInfoOpened: false,
  isEventListOpened: false,

  isNewPointFormOpened: false,
  isEditPointFormOpened: false,
  isPointInfoOpened: false,
  isPointListOpened: true,
  mapLayer: MapLayersEnum.googleMaps,
  isLocationInfoOpened: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    openNewPointForm(state, action: PayloadAction<void>) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = false

      state.isEditEventFormOpened = false
      state.isNewEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isNewPointFormOpened = true
      state.isEditPointFormOpened = false
      state.isPointInfoOpened = false

      state.isLocationInfoOpened = false
    },
    openNewPoint(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = true

      state.isEditEventFormOpened = false
      state.isNewEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isNewPointOpened = true
      state.isEditPointFormOpened = false
      state.isPointInfoOpened = false

      state.isLocationInfoOpened = false
    },
    closeNewPoint(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = true

      state.isEditEventFormOpened = false
      state.isNewEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isNewPointFormOpened = false
      state.isNewPointOpened = false
      state.isEditPointFormOpened = false
      state.isPointInfoOpened = false

      state.isLocationInfoOpened = false
    },
    openNewEventForm(state, action: PayloadAction<void>) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = true

      state.isNewEventFormOpened = true
      state.isEditEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isNewPointFormOpened = false
      state.isEditPointFormOpened = false
      state.isPointInfoOpened = false

      state.isLocationInfoOpened = false
    },
    openEditPointForm(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = false

      state.isNewEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEditEventFormOpened = false

      state.isEditPointFormOpened = true
      state.isNewPointFormOpened = false
      state.isPointInfoOpened = false

      state.isLocationInfoOpened = false
    },
    openEditEventForm(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = true

      state.isNewEventFormOpened = false
      state.isEditEventFormOpened = true
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isEditPointFormOpened = false
      state.isNewPointFormOpened = false
      state.isPointInfoOpened = false

      state.isLocationInfoOpened = false
    },
    openPointInfo(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = false

      state.isNewEventFormOpened = false
      state.isEditEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isEditPointFormOpened = false
      state.isPointInfoOpened = true
      state.isNewPointFormOpened = false

      state.isLocationInfoOpened = false
    },
    openLocationInfo(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isLocationInfoOpened = true

      state.isNewEventFormOpened = false
      state.isEditEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isPointInfoOpened = false
      state.isEditPointFormOpened = false
      state.isNewPointFormOpened = false

      state.isPointAndEventPanelOpen = false
    },
    openEventInfo(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = true

      state.isNewEventFormOpened = false
      state.isEditEventFormOpened = false
      state.isEventInfoOpened = true
      state.isEventListOpened = false

      state.isPointInfoOpened = false
      state.isEditPointFormOpened = false
      state.isNewPointFormOpened = false

      state.isLocationInfoOpened = false
    },
    closeSideBar(state) {
      state.isSideBarOpened = false
      state.isLocationInfoOpened = false
      state.isSideBarCloseInitiated = false

      state.isPointAndEventPanelOpen = false

      state.isNewEventFormOpened = false
      state.isEventInfoOpened = false
      state.isEventListOpened = false

      state.isPointInfoOpened = false
      state.isEditPointFormOpened = false
      state.isNewPointFormOpened = false

      state.isLocationInfoOpened = false
    },
    startSideBarClosing(state) {
      state.isSideBarGoingToClose = true
    },
    setSideBarClosingInitiated(state, action: PayloadAction<boolean>) {
      state.isSideBarCloseInitiated = action.payload
    },
    setInitialEventsOpenState(state) {
      state.isSideBarOpened = true
      state.isSideBarGoingToClose = false

      state.isPointAndEventPanelOpen = true

      state.isEventInfoOpened = false
      state.isEventListOpened = true
      state.isEditEventFormOpened = false

      state.isPointInfoOpened = false
      state.isEditPointFormOpened = false
      state.isNewPointFormOpened = false

      state.isLocationInfoOpened = true
    },
    closeNewPointForm(state) {
      state.isPointAndEventPanelOpen = true
      state.isNewPointFormOpened = false
      state.isEventListOpened = true
    },
    closeNewEventForm(state) {
      state.isPointAndEventPanelOpen = true
      state.isNewEventFormOpened = false
      state.isEventListOpened = true
    },
    closeEditEventForm(state) {
      state.isPointAndEventPanelOpen = true
      state.isNewEventFormOpened = false
      state.isEditEventFormOpened = false
      state.isEventInfoOpened = true
      state.isEventListOpened = false
    },
    closeEditPointForm(state) {
      state.isPointAndEventPanelOpen = true
      state.isEditPointFormOpened = false
    },
    setMapLayer: (state, action: PayloadAction<MapLayersEnum>) => {
      state.mapLayer = action.payload
    },
    setShouldLocateUser(state, action: PayloadAction<boolean>) {
      state.shouldLocateUser = action.payload
    },
    setMultiSwitchValue: (state, action) => {
      state.currentTabSelected = action.payload

      state.isEventListOpened = action.payload === 'events'
      state.isPointListOpened = action.payload !== 'events'
    },
    showPointsAndEventsPanel: (state) => {
      state.isPointAndEventPanelOpen = true
      state.isPointInfoOpened = false
      state.isPointListOpened = true
      state.isNewPointFormOpened = false
    },
  },
})

export const appActions = appSlice.actions
export const appReducer = appSlice.reducer
